import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {DatabaseProvider} from "../../providers/database/database";
import {Subject} from "rxjs";

@IonicPage()
@Component({
  selector: 'page-admin-nursinghome',
  templateUrl: 'admin-nursinghome.html',
})
export class AdminNursinghomePage {
  ngUnsubscribe : Subject<any> = new Subject();
  rows: any[];

  constructor(public navCtrl: NavController, public navParams: NavParams, public database: DatabaseProvider) {
    this.database.getNursingHomes()
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((nursing_homes) =>
      {
        this.rows = nursing_homes;
      })
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setInKroll(event, id) {
    this.database.setNursingHomeKrollToggle(event.checked, id)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminNursinghomePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-nursinghome/admin-nursinghome.ts